module.exports = __webpack_public_path__ + "img/sowhatbuy-guarantee-marquee.183ce80d.png";